module.exports = __webpack_public_path__ + "media/images/smart_phone/delivery_status_notifications/ico_derivery02-86d8b9b076338b8e57c383ddf2c78f63.png";